<template>
    <div>
        <div class="mb-3 d-flex justify-content-between align-items-center">
            <span v-if="cambiosPendientes" class="text-warning fw-bold">
                ⚠ Tienes cambios sin guardar. Presiona "{{ datos ? 'Actualizar' : 'Enviar' }}".
            </span>
            <span v-else></span>
            <button type="button" class="btn" style="background-color: #F49315; color: white;"
                    @click="abrirModalNuevo">
                + Agregar inciso
            </button>
        </div>

        <!-- ENCABEZADO -->
        <div class="form-group row col-md-12 encabezado-inspeccion">
            <div class="col-md-1"><label>Inciso</label></div>
            <div class="col-md-2"><label>Requisito</label></div>
            <div class="col-md-1"><label>Existe</label></div>
            <div class="col-md-1"><label>Campo/ Documentado</label></div>
            <div class="col-md-2"><label>Aceptación/Rechazo</label></div>
            <div class="col-md-1"><label>Cumple</label></div>
            <div class="col-md-3"><label>Observaciones</label></div>
            <div class="col-md-1"><label>Acciones</label></div>
        </div>

        <form @submit.prevent="submitForm">
            <div v-for="(pregunta, index) in preguntas"
                 :key="pregunta.inciso + '-' + index"
                 class="py-3 form-group row col-md-12 fila-inspeccion"
                 >

                <div class="col-md-1"><label>{{ pregunta.inciso }}</label></div>
                <div class="col-md-2"><label>{{ pregunta.text }}</label></div>

                <div class="col-md-1">
                    <select v-model="pregunta.existe" class="form-select">
                        <option disabled value=""></option>
                        <option value="si">Sí</option>
                        <option value="no">No</option>
                        <option value="na">N/A</option>
                    </select>
                </div>

                <div class="col-md-1">
                    <select v-model="pregunta.documento" class="form-select">
                        <option disabled value=""></option>
                        <option value="Documental">Documental</option>
                        <option value="Campo">Campo</option>
                        <option value="Documental_Campo">Documental Campo</option>
                    </select>
                </div>

                <div class="col-md-2"><label>{{ pregunta.criterio }}</label></div>

                <div class="col-md-1">
                    <select v-model="pregunta.cumple" class="form-select">
                        <option disabled value=""></option>
                        <option value="si">Sí</option>
                        <option value="no">No</option>
                    </select>
                </div>

                <div class="col-md-3">
                    <textarea class="form-control" v-model="pregunta.observaciones"></textarea>
                </div>

                <!-- ACCIONES -->
                <div class="col-md-1 acciones">
                    <div class="btn-group mb-1">
                        <button type="button" class="btn btn-sm btn-outline-secondary" title="Subir"
                                :disabled="index === 0" @click="mover(index, -1)">▲</button>
                        <button type="button" class="btn btn-sm btn-outline-secondary" title="Bajar"
                                :disabled="index === preguntas.length - 1" @click="mover(index, 1)">▼</button>
                    </div>
                    
                        <button type="button" class="btn btn-sm btn-outline-primary w-100 mb-1"
                                @click="abrirModalEditar(index)">Editar</button>
                        <button type="button" class="btn btn-sm btn-outline-danger w-100"
                                @click="eliminarInciso(index)">Eliminar</button>
                    
                </div>
            </div>

            <!-- <button type="submit" class="btn" style="background-color: #F49315; color: white;">
                {{ datos ? 'Actualizar' : 'Enviar' }}
            </button>-->
            <!-- Botón flotante para enviar -->
            <button type="submit" class="btn btn-flotante"
                    :class="{ 'btn-flotante-pendiente': cambiosPendientes }">
                {{ datos ? 'Actualizar' : 'Enviar' }}
                <span v-if="cambiosPendientes" class="punto-pendiente" title="Cambios sin guardar"></span>
            </button>
        </form>

        <!-- MODAL AGREGAR / EDITAR (dentro del div raíz) -->
        <div v-if="mostrarModalInciso" class="modal-fondo" @click.self="cerrarModal">
            <div class="modal-caja">
                <h5 class="mb-3">{{ editandoIndex === null ? 'Agregar inciso' : 'Editar inciso' }}</h5>

                <div class="mb-2">
                    <label>Inciso *</label>
                    <input v-model.trim="form.inciso" class="form-control" placeholder="Ej. XI o 3.2">
                </div>
                <div class="mb-2">
                    <label>Requisito *</label>
                    <textarea v-model.trim="form.text" class="form-control" rows="3"></textarea>
                </div>
                <div class="mb-2">
                    <label>Criterio de aceptación/rechazo *</label>
                    <textarea v-model.trim="form.criterio" class="form-control" rows="3"></textarea>
                </div>
                <div v-if="editandoIndex === null" class="mb-3">
                    <label>Insertar después de</label>
                    <select v-model="form.posicion" class="form-select">
                        <option :value="-1">Al final</option>
                        <option v-for="(p, i) in preguntas" :key="'pos' + i" :value="i">{{ p.inciso }}</option>
                    </select>
                </div>

                <div class="text-end">
                    <button type="button" class="btn btn-secondary me-2" @click="cerrarModal">Cancelar</button>
                    <button type="button" class="btn" style="background-color: #F49315; color: white;"
                            @click="guardarInciso">
                        {{ editandoIndex === null ? 'Agregar' : 'Guardar cambios' }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>
<style scoped>
.encabezado-inspeccion,
.fila-inspeccion {
    width: 100%;
    margin-left: 0;
    margin-right: 0;
}

.encabezado-inspeccion {
    text-align: center;
    align-items: center;
}

.fila-inspeccion {
    text-align: justify;
    align-items: flex-start;
}

/* Evita que los textos largos se salgan de su columna */
.fila-inspeccion label,
.encabezado-inspeccion label {
    display: block;
    width: 100%;
    overflow-wrap: break-word;
    word-wrap: break-word;
    white-space: normal;
}

/* Evita que los select se salgan */
.fila-inspeccion .form-select {
    width: 100%;
    max-width: 100%;
}

/* Observaciones */
.fila-inspeccion textarea {
    width: 100%;
    min-height: 80px;
    resize: vertical;
}

/* Incisos agregados por el usuario */
.fila-personalizada {
    background-color: #fff8ec;
}

.acciones {
    text-align: center;
}

/* Espacio al final para que el botón flotante no tape la última fila */
form {
    padding-bottom: 80px;
}

/* Botón flotante de Enviar / Actualizar */
.btn-flotante {
    position: fixed;
    right: 30px;
    bottom: 30px;
    z-index: 1040; /* debajo del modal (1050) */
    background-color: #F49315;
    color: white;
    padding: 12px 28px;
    font-weight: bold;
    border-radius: 30px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);
}

.btn-flotante:hover,
.btn-flotante:focus {
    background-color: #d97f0c;
    color: white;
}

/* Cuando hay cambios sin guardar */
.btn-flotante-pendiente {
    box-shadow: 0 0 0 4px rgba(244, 147, 21, 0.35), 0 4px 12px rgba(0, 0, 0, 0.25);
}

.punto-pendiente {
    display: inline-block;
    width: 9px;
    height: 9px;
    margin-left: 8px;
    border-radius: 50%;
    background-color: #fff;
    vertical-align: middle;
}

@media (max-width: 768px) {
    .btn-flotante {
        right: 15px;
        bottom: 15px;
        padding: 10px 20px;
    }
}

/* En pantallas pequeñas */
@media (max-width: 768px) {
    .encabezado-inspeccion > div,
    .fila-inspeccion > div {
        margin-bottom: 8px;
    }
}

/* Modal */
.modal-fondo {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1050;
}

.modal-caja {
    background: #fff;
    border-radius: 8px;
    padding: 20px;
    width: 90%;
    max-width: 600px;
    max-height: 90vh;
    overflow-y: auto;
}
</style>

<script>
import axios from 'axios';
import Swal from 'sweetalert2';

// Preguntas "de cajón"
const PREGUNTAS_BASE = [
    
          {inciso:'I (a', text: 'Seccion II. Procedimiento de Inspección Disposiciones aplicables a la obra o instalación eléctrica, distinta a las Normas Oficiales Mexicanas como son: NMX, NRF, NI, STD y demás especificaciones técnicas aplicables, contenidas en la memoria técnica descriptiva.', existe:    '', documento: 'DOCUMENTAL / CAMPO', criterio:'Se acepta si se indica en el Oficio Resolutivo emitido por el distribuidor define: 1) Que el servicio se refiere a una “Solicitud de Interconexión de Central de Generación Distribuida 2) Determina la'+
' especificación del equipo de medición requerido en el punto de Interconexión, 3) Define el esquema de interconexión de acuerdo con la “RESOLUCION de la Comisión Nacional de Energía por la que expide las disposiciones administrativas de carácter general, los modelos de contrato, la metodología de cálculo de contraprestación y las especificaciones técnicas generales, aplicables a las centrales eléctricas de generación distribuida y generación limpia distribuida” de fecha 07/03/2017, 4) se describe en la memoria técnica y diagrama unifilar como se atendió lo indicado en el oficio'+
' resolutivo emitido por el distribuidor”,',cumple: '', observaciones: '' },
{inciso:'I', text: 'Capacidad Instalada de las Instalaciones (MVA, MW, y MVAR).', existe:    '', documento: '', criterio:'Cumple si se indica en la Memoria Técnico-Descriptiva (MTD) la Capacidad Instalada de las Instalaciones (MVA, MW, y MVAR).',cumple: '', observaciones: '' },
                   {inciso:'II', text: 'Potencia nominal o neta (MVA, MW, MVAR).', existe: '', documento: '', criterio:'Cumple si se indica en la MTD Potencia nominal o neta (MVA, MW, MVAR).la Potencia nominal o neta (MVA, MW, MVAR).',cumple: '', observaciones: '' },
                   {inciso:'III', text: 'Derechos de vía', existe: '', documento: '', criterio:'Cumple si se indican en la MTD los derechos de vía del proyecto',cumple: '', observaciones: '' },
         
                   {inciso:'IV', text: 'Localidades, áreas o regiones geográficas donde operan las instalaciones; Croquis de localización del domicilio donde se ubican las instalaciones', existe: '', documento: '', criterio:' Cumple si se indica en la MTD las localidades, áreas o regiones geográficas donde operan las instalaciones; cumple si el proyecto contiene Croquis de localización del domicilio donde se ubican las instalaciones',cumple: '', observaciones: '' },
         
                   {inciso:'V', text: ' Descripción de las instalaciones. - Configuraciones, Esquemas, Estructuras y Especificaciones de las instalaciones, sistemas de emergencia y sistemas auxiliares, conforme a las disposiciones aplicables.', existe: '', documento: '', criterio:' Cumple si se indica en la MTD la descripción de las instalaciones. - Configuraciones, Esquemas, Estructuras y Especificaciones de las instalaciones, sistemas de emergencia y sistemas auxiliares, conforme a las disposiciones aplicables ',cumple: '', observaciones: '' },
         
                   {inciso:'VI', text: 'Características específicas de:', existe: '', documento: '', criterio:'Cumple si se indican en la MTD las características específicas de;',cumple: '', observaciones: '' },
         
                   {inciso:'VI (a', text: ' Interconexión y/o Conexión. - dimensionamiento, extensión, trayectoria, canalizaciones, soportes y estructuras, aislamiento y capacidad eléctrica de los conductores o alimentadores desde los equipos de generación a la interconexión y/o de la conexión hasta los Centros de Carga; tableros de distribución de potencia, sistemas auxiliares como alumbrado, enfriamiento, banco de baterías, entre otros', existe: '', documento: '', criterio:'Cumple si para la Interconexión y/o Conexión. Se entrega la siguiente información: - dimensionamiento, extensión, trayectoria, canalizaciones, soportes y estructuras, aislamiento y capacidad eléctrica de los conductores o alimentadores desde los equipos de generación a la interconexión y/o de la conexión hasta los Centros de Carga; tableros de distribución de potencia, sistemas auxiliares como alumbrado, enfriamiento, banco de baterías, entre otros',cumple: '', observaciones: '' },
                   {inciso:'VI (b', text: 'Características específicas de la subestación, acometida o punto de interconexión/conexión, (configuración, instrumentación y control, esquemas de protección, sistemas de tierras,sistemas auxiliares, entre otros);', existe: '', documento: '', 
                   criterio:'Cumple si se indican en la MTD las características específicas de la subestación, acometida o punto de interconexión/conexión, (configuración, instrumentación y control, esquemas de protección, sistemas de tierras, sistemas auxiliares, entre otros);',cumple: '', observaciones: '' },
         
                   {inciso:'VI (c', text: 'Tipo de dispositivos de desconexión o interrupción, capacidad interruptiva, ajuste de las protecciones asociadas', existe: '', documento: '', criterio:'Cumple si se indican en la MTD las características específicas de Tipos de dispositivos de desconexión o interrupción, capacidad interruptiva, ajuste de las protecciones asociadas',cumple: '', observaciones: '' },
         
                   {inciso:'VI (d', text: ' Otros sistemas, tales como: de emergencia (paro, sobrecalentamiento, derrame, fuga, contra-incendio, de comunicaciones)', existe: '', documento: '', criterio:'Cumple si se indican en la MTD las características específicas de otros sistemas, tales como: de emergencia (paro, sobrecalentamiento, derrame, fuga, contra-incendio, de comunicaciones)',cumple: '', observaciones: '' },
         
                   {inciso:'VII', text: 'Planos eléctricos, tales como diagramas unifilares, croquis de localización, de detalle, o cualquier otro que describan la configuración de las instalaciones, la instrumentación y control, las protecciones',existe: '', documento: '',criterio:'Cumple si entrega  planos eléctricos, tales como diagramas unifilares, croquis de localización, de detalle, o cualquier otro que describan la configuración de las instalaciones, la instrumentación y control, las protecciones,',cumple: '', observaciones: '' },
         
                   {inciso:'VII (a', text:'Elaborarse a una escala tal que el contenido sea legible e interpretable. Se permite el uso de archivos electrónicos en la elaboración de los planos eléctricos', existe: '', documento: '', criterio:'Cumple si los planos eléctricos se han elaborado a una escala tal que el contenido sea legible e interpretable. Se permite el uso de archivos electrónicos en la elaboración de los planos eléctricos  ',cumple: '', observaciones: '' },
                   
                   {inciso:'VII (b', text:'Incorporar el Sistema General de Unidades de Medida, de acuerdo con la Norma Oficial Mexicana NOM-008-SCFI vigente y todas sus leyendas en idioma español', existe: '', documento: '', criterio:'Cumple si los planos eléctricos han incorporado  el Sistema General de Unidades de Medida, de acuerdo con la Norma Oficial Mexicana NOM-008-SCFI vigente y todas sus leyendas en idioma español',cumple: '', observaciones: '' },
         
                   {inciso:'VII (c', text:'Contener los datos relativos a la instalación eléctrica e incluir la información suficiente para una correcta interpretación, de manera que permita construir la instalación.', existe: '', documento: '', criterio:'Cumple si los planos eléctricos contienen los datos relativos a la instalación eléctrica e incluiyen la información suficiente para una correcta interpretación, de manera que permita construir la instalación',cumple: '', observaciones: '' },
                   
                   {inciso:'VII (d', text:'Incluir la información siguiente:del Solicitante de la Inspección 1. Nombre o razón social  2 Domicilio (calle, número, colonia o población, municipio o delegación, código postal y entidad federativa). 3. Teléfono. 4. Dirección de correo electrónico. Del Responsable de la instalación: 1. Nombre completo. 2. Número de cédula profesional. 3. Firma o carta responsiva, cuando el proyecto sea entregado en medios electrónicos. 4. Fecha de elaboración del Proyecto eléctrico', 
                   existe: '', documento: '', criterio:'Cumple si el proyecto incluye la siguiente información del So9licitante de la Inspección 1. Nombre o razón social 2 Domicilio (calle, número, colonia o población, municipio o delegación, código postal yentidad federativa). 3. Teléfono. 4. Dirección de correo electrónico Del Responsable de la instalación 1. Nombre completo. 2. Número de cédula profesional. 3. Firma o carta responsiva, cuando el proyecto sea entregado en medios electrónicos. 4. Fecha de elaboración del Proyecto eléctrico ',cumple: '', observaciones: '' },
         
                   {inciso:'VIII', text: 'Lista de los principales materiales utilizados', existe: '', documento: '', criterio:'Cumple si entrega: Lista de los principales materiales utilizados',cumple: '', observaciones: '' },
         
                   {inciso:'IX', text: 'Lista de los principales equipos utilizados', existe: '', documento: '', criterio:'Cumple si entrega: Lista de los principales equipos utilizados',cumple: '', observaciones: '' },
         
                   {inciso:'X', text: 'Coordenadas y croquis de localización del domicilio donde se ubica la Central Eléctrica o el Centro de Carga', existe: '', documento: '', criterio:'Cumple si el proyecto contiene; Coordenadas y croquis de localización del domicilio donde se ubica la Central Eléctrica o el Centro de Carga',cumple: '', observaciones: '' },
         
                   {inciso:'XL', text: 'Memorias de cálculo las cuales deben contener, de manera enunciativa mas no limitativa: a) Estudios de corto circuito; b) Sistemas de tierras; c) Coordinación de Aislamientos; d) Coordinación de protecciones; e) Dimensionamiento y Selección subestación o acometida; f) Capacidad de transformación; g) Dimensionamiento y parámetros de Líneas transmisión, y h) Dimensionamiento y parámetros de Redes de distribución', existe: '', documento: '', criterio:'Cumple si las Memorias de cálculo contienen de manera enunciativa; Memorias de cálculo las cuales deben contener, de manera enunciativa mas no limitativa: a) Estudios de corto circuito; b) Sistemas de tierras; c) Coordinación de Aislamientos; d) Coordinación de protecciones; e) Dimensionamiento y Selección subestación o acometida; f) Capacidad de transformación; g) Dimensionamiento y parámetros de Líneas transmisión, y h) Dimensionamiento y parámetros de Redes de distribución',cumple: '', observaciones: '' },
                    {inciso:'3.1', text: 'Configuración y protecciones. El equipo de generación de la Central Eléctrica con capacidad menor a 0.5 MW debe contar invariablemente con las siguientes protecciones: sobrecorriente, sobretensión, baja tensión, variaciones de frecuencia, antiisla, potencia inversa y perdida de sincronismo (estas dos últimas en caso de aplicar).', existe: '', documento: '', criterio:'Cumple cuando proporciona documentos o evidencia que demuestren que se cuenta con las siguientes protecciones: 1) Sobrecorriente, 2) Sobretension, 3) Baja tensión, 4) Variaciones de frecuencia 5) Anti-isla.',cumple: '', observaciones: '' },
  
];

const INCISOS_BASE = PREGUNTAS_BASE.map(p => String(p.inciso).trim());
const SOLO_GD = ['I (a', '3.1'];

export default {
    data() {
        return {
            datos: false,
            tipo: '',
            idcotizacion: '',
            esGeneracionDistribuida: false,
            cambiosPendientes: false,
            mostrarModalInciso: false,
            editandoIndex: null,
            form: { inciso: '', text: '', criterio: '', posicion: -1 },
            preguntas: PREGUNTAS_BASE.map(p => ({ ...p, personalizado: false }))
        };
    },

    mounted() {
        this.getInspecciones();
    },

    methods: {
        getInspecciones() {
            const id = localStorage.getItem('idcotizacion');

            axios.post(this.$rutaServer + 'consultarListaInspecciones', { idcotizacion: id })
                .then(response => {
                    const inspecciones = response.data.inspecciones || [];
                    const tipo = response.data.coti?.[0]?.tipo || '';
                    const tipo_sep = tipo.split(' - ')[0];

                    this.tipo = tipo_sep;
                    this.esGeneracionDistribuida = tipo_sep === 'Generación Distribuida';

                    let preguntasCargadas;

                    if (inspecciones.length > 0) {
                        this.datos = true;
                        preguntasCargadas = inspecciones.map(i => ({
                            inciso: i.inciso,
                            text: i.requisito,
                            existe: i.existe,
                            documento: i.documento,
                            criterio: i.criterio,
                            cumple: i.cumple,
                            observaciones: i.observaciones,
                            personalizado: !INCISOS_BASE.includes(String(i.inciso).trim())
                        }));
                    } else {
                        this.datos = false;
                        preguntasCargadas = PREGUNTAS_BASE.map(p => ({ ...p, personalizado: false }));
                    }

                    // Si NO es Generación Distribuida, quitar I (a) y 3.1
                    if (!this.esGeneracionDistribuida) {
                        preguntasCargadas = preguntasCargadas.filter(
                            p => !SOLO_GD.includes(String(p.inciso).trim())
                        );
                    }

                    this.preguntas = preguntasCargadas;
                })
                .catch(error => console.error('Error al obtener las inspecciones:', error));
        },

        // ---------- MODAL ----------
        abrirModalNuevo() {
            this.editandoIndex = null;
            this.form = { inciso: '', text: '', criterio: '', posicion: -1 };
            this.mostrarModalInciso = true;
        },

        abrirModalEditar(index) {
            const p = this.preguntas[index];
            this.editandoIndex = index;
            this.form = { inciso: p.inciso, text: p.text, criterio: p.criterio, posicion: -1 };
            this.mostrarModalInciso = true;
        },

        cerrarModal() {
            this.mostrarModalInciso = false;
            this.editandoIndex = null;
        },

        guardarInciso() {
            const { inciso, text, criterio, posicion } = this.form;

            if (!inciso || !text || !criterio) {
                Swal.fire('¡Error!', 'Inciso, requisito y criterio son obligatorios', 'error');
                return;
            }

            // No repetir incisos ni usar uno de cajón (excepto el mismo que se edita)
            const repetido = this.preguntas.some((p, i) =>
                i !== this.editandoIndex &&
                String(p.inciso).trim().toLowerCase() === inciso.toLowerCase()
            );
            if (repetido) {
                Swal.fire('¡Error!', 'Ya existe un inciso con ese identificador', 'error');
                return;
            }

            if (this.editandoIndex === null) {
                const nueva = {
                    inciso, text, criterio,
                    existe: '', documento: '', cumple: '', observaciones: '',
                    personalizado: true
                };
                if (posicion === -1) this.preguntas.push(nueva);
                else this.preguntas.splice(posicion + 1, 0, nueva);
            } else {
                Object.assign(this.preguntas[this.editandoIndex], { inciso, text, criterio });
            }

            this.cambiosPendientes = true;
            this.cerrarModal();
        },

        // ---------- ORDEN ----------
        mover(index, direccion) {
            const destino = index + direccion;
            if (destino < 0 || destino >= this.preguntas.length) return;
            const [item] = this.preguntas.splice(index, 1);
            this.preguntas.splice(destino, 0, item);
            this.cambiosPendientes = true;
        },

        // ---------- ELIMINAR ----------
        eliminarInciso(index) {
            Swal.fire({
                title: `¿Eliminar el inciso "${this.preguntas[index].inciso}"?`,
                text: 'Se eliminará definitivamente al guardar la lista.',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Sí, eliminar',
                cancelButtonText: 'Cancelar'
            }).then(result => {
                if (result.isConfirmed) {
                    this.preguntas.splice(index, 1);
                    this.cambiosPendientes = true;
                }
            });
        },

        // ---------- GUARDAR ----------
        async submitForm() {
            const incompleta = this.preguntas.find(p => !p.existe || !p.documento || !p.cumple);
            if (incompleta) {
                Swal.fire('¡Error!', `Llena Existe, Campo/Documentado y Cumple en el inciso ${incompleta.inciso}`, 'error');
                return;
            }

            try {
                this.idcotizacion = localStorage.getItem('idcotizacion');
                await axios.post(this.$rutaServer + 'guardarDatosListaInspeccion', {
                    preguntas: this.preguntas,
                    idcotizacion: this.idcotizacion
                });
                this.datos = true;
                this.cambiosPendientes = false;
                Swal.fire('¡Éxito!', 'Datos registrados', 'success');
            } catch (error) {
                console.error('Error al enviar los datos:', error.response?.data || error);
                Swal.fire('¡Error!', 'Ocurrió un error al guardar', 'error');
            }
        }
    }
};
</script>